import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import BookingView from '../components/BookingView';
import { detectAppSurface } from '../lib/hosts';
import { usePublicQuote } from '../lib/usePublicQuote';

const BookingPage = () => {
  const [params] = useSearchParams();
  const quoteId = params.get('q');
  const { quote, loading, error } = usePublicQuote(quoteId);
  const surface = detectAppSurface();

  const hostLabel = surface === 'booking' ? 'booking.skyluxtravel' : `${window.location.host}/booking`;

  useEffect(() => {
    if (!quote) {
      document.title = 'SkyLux Travel';
      return;
    }
    const dest = quote.flight.arrival || 'your destination';
    document.title = `Skylux Travel: Quote - Flight to ${dest}`;

    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex,nofollow';
    document.head.appendChild(meta);
    return () => {
      document.title = 'SkyLux Travel';
      document.head.removeChild(meta);
    };
  }, [quote]);

  if (!quoteId) {
    return (
      <div style={{ minHeight: '100vh', background: '#f5f4f4', color: '#414141', fontFamily: "'Open Sans', sans-serif" }}>
        <main style={{ maxWidth: '640px', margin: '3rem auto', padding: '0 2rem', textAlign: 'center' }}>
          <p style={{ color: '#84878d' }}>Missing quote reference. Open the link from your SkyLux email.</p>
        </main>
      </div>
    );
  }

  if (loading && !quote) {
    return (
      <div
        style={{
          minHeight: '100vh',
          background: '#f5f4f4',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: "'Open Sans', sans-serif",
        }}
      >
        <p style={{ color: '#84878d' }}>Loading your quote…</p>
      </div>
    );
  }

  if (!quote) {
    return (
      <div style={{ minHeight: '100vh', background: '#f5f4f4', color: '#414141', fontFamily: "'Open Sans', sans-serif" }}>
        <header style={{ background: 'white', borderBottom: '1px solid #ededed', padding: '1rem 2rem' }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <img src={`${process.env.PUBLIC_URL}/header-logo.svg`} alt="SkyLux Travel" style={{ maxHeight: 35 }} />
            <p style={{ fontSize: '0.8rem', color: '#84878d', marginTop: '0.25rem' }}>{hostLabel}</p>
          </div>
        </header>
        <main style={{ maxWidth: '640px', margin: '3rem auto', padding: '0 2rem', textAlign: 'center' }}>
          <p style={{ color: '#84878d', marginBottom: '1rem' }}>This quote link is invalid or expired.</p>
          <p style={{ fontSize: '0.875rem', color: '#84878d' }}>
            {error ?? 'Open the link from your latest Skylux email, or contact your agent.'}
          </p>
        </main>
      </div>
    );
  }

  return <BookingView quote={quote} />;
};

export default BookingPage;
